const iswcCashPrize = {

    "PW1":130,
    "PW2":130,
    "PW3":130,
    "PW4":200,
    "PW5":260,

    
    "SS1":130,
    "SS2":130,
    "SS3":130,
    "SS4":200,
    "SS5":260,

    
    "PV1":130,
    "PV2":130,
    "PV3":130,
    "PV4":200,
    "PV5":260,

    "DS1":130,
    "DS2":130,
    "DS3":130,
    "DS4":200,
    "DS5":260,

    
    "PW1":130,
    "PW2":130,
    "PW3":130,
    "PW4":200,
    "PW5":260,

    "PS1":240,
    "PS2":240,
    "PS3":240,
    "PS4":280,
    "PS5":300,


     "RS1":240,
    "RS2":240,
    "RS3":240,
    "RS4":280,
    "RS5":300,

     "BC1":240,
    "BC2":240,
    "BC3":240,
    "BC4":280,
    "BC5":300,

     "TT1":240,
    "TT2":240,
    "TT3":240,
    "TT4":280,
    "TT5":300,

    "DP1":240,
    "DP2":240,
    "DP3":240,
    "DP4":280,
    "DP5":300,
   
}

export default iswcCashPrize;